<!-- <div class="content" style="background-color: #408fd2;" >
    <div class="wrapper" style="background-color: #002554; height: 90%;" >
        <mat-icon class="btnRegresa" *ngIf="enviarReset" matTooltip="Volver" (click)="enviarReset = false; form.reset()">arrow_back_ios</mat-icon>
        <div class="wrapper__logo">
            <img src="assets/img/ROTO-logo.svg" alt="IES">
        </div>
        <p class="txt-texto mb-0 version text-center" style="transform: translateY(-10px);">
            v {{version}}
        </p>

        <div class="wrapper__group form-group" [formGroup]="form" *ngIf="!enviarReset">
            <mat-form-field appearance="outline" floatLabel="always">
                <mat-label style="color:white">Usuario:</mat-label>
                <input matInput type="text" formControlName="username" autocomplete="off" style="height:50px;border-radius: 15px;padding-left: 10px; padding-right: 10px; background-color: white;">
            </mat-form-field>
            <mat-form-field appearance="outline" floatLabel="always">
                <mat-label style="color:white">Contraseña:</mat-label>
                <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" autocomplete="off"
                       style="height:50px;border-radius: 15px;padding-left: 10px; padding-right: 10px;background-color: white;">
                <button mat-icon-button matSuffix (click)="togglePasswordVisibility()" style="margin-top: -20px !important;">
                  <mat-icon style="color:white;">{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
              </mat-form-field>

            <label class="w-100 text-center mt-4 txtR" style="color:#408fd2 !important" (click)="enviarReset = true; formReset.reset()">¿Olvidó su contraseña?</label>
            <label style="font-weight: 600;" class="w-100 text-center mt-3 mb-3">{{msjError}}</label>
            <button type="button" class="wrapper__btn-ingresar" style="background-color:#408fd2 !important" (click)="ingresar()">INGRESAR</button>
        </div>
        <div class="wrapper__group form-group" [formGroup]="formReset" *ngIf="enviarReset">
            <label class="mt-3 mb-3 w-100 text-justify txtLeyenda">Es necesario que ingrese su usuario para poder enviale por correo electrónico la recuperación de su contraseña</label> <br>
            <mat-form-field class="mb-5">
                <mat-label>Ingrese su usuario</mat-label>
                <input matInput type="text" formControlName="loginName" autocomplete="off">
            </mat-form-field>
            <button type="button" class="wrapper__btn-ingresar" (click)="recuperar()" [disabled]="formReset.invalid">RECUPERAR</button>
        </div>

    </div>
</div>

 -->



 <div class="content" style="background-color: #408fd2;">
    <div class="wrapper" style="background-color: #002554; height: 90%;">
      <mat-icon class="btnRegresa" *ngIf="enviarReset" matTooltip="Volver" (click)="enviarReset = false; form.reset()">arrow_back_ios</mat-icon>
      <div class="wrapper__logo">
        <img src="assets/img/ROTO-logo.svg" alt="IES">
      </div>
      <p class="txt-texto mb-0 version text-center" style="transform: translateY(-10px);">
        v {{version}}
      </p>
  
      <div class="wrapper__group form-group" [formGroup]="form" *ngIf="!enviarReset">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label style="color:white">Usuario:</mat-label>
          <input matInput type="text" formControlName="username" autocomplete="off" style="height:50px;border-radius: 15px;padding-left: 10px; padding-right: 10px; background-color: white;">
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label style="color:white">Contraseña:</mat-label>
          <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" autocomplete="off"
                 style="height:50px;border-radius: 15px;padding-left: 10px; padding-right: 10px;background-color: white;">
          <button mat-icon-button matSuffix (click)="togglePasswordVisibility()" style="margin-top: -20px !important;">
            <mat-icon style="color:white;">{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>
        </mat-form-field>
  
        <label class="w-100 text-center mt-4 txtR" style="color:#408fd2 !important" (click)="enviarReset = true; formReset.reset()">¿Olvidó su contraseña?</label>
        <label style="font-weight: 600;" class="w-100 text-center mt-3 mb-3">{{msjError}}</label>
        <button type="button" class="wrapper__btn-ingresar" style="background-color:#408fd2 !important" (click)="ingresar()">INGRESAR</button>
  
        <!-- Login de Google -->
        <div class="google-login text-center" style="margin-top: 20px;">
          <span (click)="oauth()">
            <!-- Se asume que cuentas con el logo de Google en la ruta especificada -->
            <img src="assets/img/google.png" alt="Google Login" style="width:40px; cursor:pointer;">
          </span>
          <p style="color:white; font-size: 0.9em; margin-top: 5px;">Solo cuentas con el dominio de Rotoplas</p>
        </div>
      </div>
  
      <div class="wrapper__group form-group" [formGroup]="formReset" *ngIf="enviarReset">
        <label class="mt-3 mb-3 w-100 text-justify txtLeyenda" style="color:white;">
          Es necesario que ingrese su usuario para poder enviale por correo electrónico la recuperación de su contraseña
        </label>
        <br>
        <mat-form-field class="mb-5">
          <mat-label style="color: white;">Ingrese su usuario</mat-label>
          <input matInput type="text" formControlName="loginName" autocomplete="off" style="color:white;">
        </mat-form-field>
        <button style="background-color:#408fd2 !important" type="button" class="wrapper__btn-ingresar" (click)="recuperar()" [disabled]="formReset.invalid">RECUPERAR</button>
      </div>
  
    </div>
  </div>